import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_ctx.isInProofreading)
    ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        link: "",
        type: "primary",
        size: "small",
        onClick: _withModifiers(_ctx.openProofreadingDoc, ["prevent"]),
        onMouseup: _withModifiers(_ctx.openProofreadingDocInNewTab, ["middle"])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('fileActions.view')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "onMouseup"]))
    : (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        link: "",
        type: "primary",
        size: "small",
        disabled: _ctx.isEditingBlocked,
        onClick: _withModifiers(_ctx.openDoc, ["prevent"]),
        onMouseup: _withModifiers(_ctx.openDocInNewTab, ["middle"])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('fileActions.edit')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick", "onMouseup"]))
}